<!-- Mashos Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Masho Management</h3>
    </div>
    <div class="card-toolbar">
      <div class="d-flex justify-content-end" data-kt-customer-table-toolbar="base">
        <!-- Filter Button -->
        <button
          type="button"
          class="btn btn-sm btn-dark fw-bold d-flex me-3"
          (click)="toggleFilters()">
          <i class="ki-duotone ki-magnifier fs-6 text-muted me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Search
        </button>

        <!-- Search -->
        <!-- <div class="d-flex align-items-center position-relative me-3">
          <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-3">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <input
            type="text"
            class="form-control form-control-sm w-250px ps-10"
            placeholder="Search mashos..."
            [(ngModel)]="searchTerm"
            (keyup.enter)="applyFilters()"
          />
        </div> -->

        <!-- Add Masho Button -->
        <button
          type="button"
          class="btn btn-sm btn-primary fw-bold d-flex"
          (click)="openAddMashoModal()">
          <i class="ki-duotone ki-plus fs-2"></i>
          Add Masho
        </button>
      </div>
    </div>
  </div>

  <!-- Filter Section -->
  <div class="card-body border-bottom py-4" *ngIf="showFiltersForm">
    <div class="row g-4">
      <!-- Masho Date From -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Masho Date From</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.masho_date_from"
        />
      </div>

      <!-- Masho Date To -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Masho Date To</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.masho_date_to"
        />
      </div>

      <!-- Valid Upto From -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Valid Upto From</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.valid_upto_from"
        />
      </div>

      <!-- Valid Upto To -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Valid Upto To</label>
        <input
          type="date"
          class="form-control form-control-sm"
          [(ngModel)]="filters.valid_upto_to"
        />
      </div>
    </div>

    <div class="row g-4 mt-2">
      <!-- Search Keyword -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Search Keyword</label>
        <input
          type="text"
          class="form-control form-control-sm"
          placeholder="Enter keyword..."
          [(ngModel)]="filters.search"
        />
      </div>

      <!-- Filter Actions -->
      <div class="col-md-9 d-flex align-items-end">
        <button
          type="button"
          class="btn btn-sm btn-primary me-2"
          (click)="applyFilters()">
          Apply Filters
        </button>
        <button
          type="button"
          class="btn btn-sm btn-light"
          (click)="clearFilters()">
          Clear
        </button>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Mashos Table -->
    <div class="table-responsive">
      <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
        <thead>
          <tr class="fw-bold text-muted bg-light">
            <th class="min-w-150px">Stock</th>
            <th class="min-w-150px">Chassis Number</th>
            <th class="min-w-120px">Masho Date</th>
            <th class="min-w-120px">Valid Until Date</th>
            <th class="min-w-200px">Admin Comment</th>
            <th class="min-w-100px text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <!-- Loading State -->
          <tr *ngIf="isLoading">
            <td colspan="6" class="text-center py-5">
              <div class="d-flex justify-content-center align-items-center">
                <span class="spinner-border spinner-border-sm me-2"></span>
                Loading mashos...
              </div>
            </td>
          </tr>

          <!-- Empty State -->
          <tr *ngIf="!isLoading && mashos.length === 0">
            <td colspan="6" class="text-center py-5">
              <div class="text-muted">No mashos found</div>
            </td>
          </tr>

          <!-- Data Rows -->
          <tr *ngFor="let masho of mashos; trackBy: trackByFn">
            <td>
              <div class="d-flex align-items-center">
                <div class="symbol symbol-40px me-3">
                        <img [src]="getVehicleImageUrl(masho.vehicle)" [alt]="masho.vehicle.name || 'Vehicle'" class="symbol-label"
                          style="object-fit: cover;">
                      </div>
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary fs-6">
                    {{ masho.vehicle?.car_no || masho.stock_id || '-' }}
                  </span>
                  <span class="text-muted fw-semibold text-muted d-block fs-7">
                    {{ masho.vehicle?.company_name || '-' }} {{ masho.vehicle?.name || '-' }}
                  </span>
                </div>
              </div>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ masho.vehicle?.vin_no  }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ masho.masho_date | date:'dd/MM/yyyy' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ masho.valid_until_date | date:'dd/MM/yyyy' }}
              </span>
            </td>
            <td>
              <span class="text-dark fw-semibold d-block fs-7">
                {{ masho.admin_comment || '-' }}
              </span>
            </td>
            <td class="text-end">
              <div class="d-flex justify-content-end gap-2">
                <!-- Edit Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-primary"
                  (click)="openEditMashoModal(masho)"
                  title="Edit Transport Pickup">
                  <i class="ki-duotone ki-pencil fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Icon -->
                <!-- <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-danger"
                  (click)="deleteTransportPickup(transportPickup)"
                  title="Delete Transport Pickup">
                  <i class="ki-duotone ki-trash fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button> -->
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <app-pagination
      *ngIf="!isLoading && mashos.length > 0"
      [paginationInfo]="paginationInfo"
      [loading]="isLoading"
      (pageChange)="onPageChange($event)">
    </app-pagination>
  </div>
</div>
